(() => {
  const links = Array.from(document.querySelectorAll('a[data-trm-collection-link]'));
  if (!links.length) return;

  const checked = new Map();

  const hideLink = (link) => {
    const item = link.closest('li.navigation-item, li.navigation-mobile-item');
    if (item) item.hidden = true;
    else link.hidden = true;
  };

  const check = async (link) => {
    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (_) {
      return;
    }
    if (url.origin !== window.location.origin || !url.pathname.startsWith('/collections/')) return;

    const key = url.pathname.replace(/\/$/, '');
    if (!checked.has(key)) {
      checked.set(key, fetch(`${key}/products.json?limit=1`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      }).then((response) => ({ ok: response.ok, status: response.status })).catch(() => ({ ok: true, status: 0 })));
    }

    const result = await checked.get(key);
    if (!result.ok && result.status === 404) hideLink(link);
  };

  const run = () => links.forEach((link) => check(link));
  if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 1500 });
  else setTimeout(run, 250);
})();
